/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Station,
    StationFromJSON,
    StationFromJSONTyped,
    StationToJSON,
} from './';

/**
 * 
 * @export
 * @interface StationListBusinessDataResponse
 */
export interface StationListBusinessDataResponse {
    /**
     * 
     * @type {number}
     * @memberof StationListBusinessDataResponse
     */
    watermark?: number;
    /**
     * 
     * @type {Array<Station>}
     * @memberof StationListBusinessDataResponse
     */
    businessData?: Array<Station> | null;
    /**
     * 
     * @type {number}
     * @memberof StationListBusinessDataResponse
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof StationListBusinessDataResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof StationListBusinessDataResponse
     */
    totalRecords?: number;
}

export function StationListBusinessDataResponseFromJSON(json: any): StationListBusinessDataResponse {
    return StationListBusinessDataResponseFromJSONTyped(json, false);
}

export function StationListBusinessDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationListBusinessDataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'watermark': !exists(json, 'watermark') ? undefined : json['watermark'],
        'businessData': !exists(json, 'businessData') ? undefined : (json['businessData'] === null ? null : (json['businessData'] as Array<any>).map(StationFromJSON)),
        'pageNumber': !exists(json, 'pageNumber') ? undefined : json['pageNumber'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
    };
}

export function StationListBusinessDataResponseToJSON(value?: StationListBusinessDataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'watermark': value.watermark,
        'businessData': value.businessData === undefined ? undefined : (value.businessData === null ? null : (value.businessData as Array<any>).map(StationToJSON)),
        'pageNumber': value.pageNumber,
        'pageSize': value.pageSize,
        'totalRecords': value.totalRecords,
    };
}


